import React from 'react'
import { useTranslation } from 'react-i18next'

import { Title } from '../../../../components/presentation/Text'
import PdfBasicOptionsForm from '../../../../components/pdf/options/PdfBasicOptionsForm'
import Separator from '../../../../components/helpers/Separator'
import SeparatorWrapper from '../../../../components/helpers/SeparatorWrapper'
import Sticky from '../../../../components/helpers/Sticky'
import { COLORS } from '@btime/constants'
import CheckboxListItem from '../../../../components/list/CheckboxListItem'
import {
  usePdfOptionsForm,
  usePdfOptionsFormActions
} from '../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import { useSessionChecker } from '@btime/react-session'
import HeaderImage from './headerImage/HeaderImage'

const CustomOptionsForm = () => {
  const form = usePdfOptionsForm()
  const [isLogged] = useSessionChecker()
  const { handleChange } = usePdfOptionsFormActions()
  const { t } = useTranslation('serviceOrders')

  return (
    <>
      <CheckboxListItem
        selected={form.showQuestionInfo}
        onSelect={handleChange('showQuestionInfo')}
        label={t('pdf.options.showQuestionInfo')}
        invert
      />
      {isLogged && (
        <>
          <CheckboxListItem
            selected={form.hideConfidentialInfo}
            onSelect={handleChange('hideConfidentialInfo')}
            label={t('pdf.options.hideConfidentialInfo')}
            invert
          />
          <CheckboxListItem
            selected={form.hidePrivateQuestion}
            onSelect={handleChange('hidePrivateQuestion')}
            label={t('pdf.options.hidePrivateQuestion')}
            invert
          />
        </>
      )}
      <CheckboxListItem
        selected={form.hideChildrenServiceOrders}
        onSelect={handleChange('hideChildrenServiceOrders')}
        label={t('pdf.options.hideChildrenServiceOrders')}
        invert
      />
      {!form.hideChildrenServiceOrders && (
        <>
          <Title size="h6" color={COLORS.dark3} style={{ marginLeft: '20px', marginTop: '10px' }}>
            {t('pdf.options.childrenFieldsTitle')}
          </Title>
          <CheckboxListItem
            selected={form.showChildrenActive}
            onSelect={handleChange('showChildrenActive')}
            label={t('pdf.options.showField', { field: t('show.asset') })}
            invert
            style={{ marginLeft: '20px' }}
          />
          <CheckboxListItem
            selected={form.showChildrenQuestionnaire}
            onSelect={handleChange('showChildrenQuestionnaire')}
            label={t('pdf.options.showField', { field: t('show.checklist') })}
            invert
            style={{ marginLeft: '20px' }}
          />
          <CheckboxListItem
            selected={form.showChildrenDestination}
            onSelect={handleChange('showChildrenDestination')}
            label={t('pdf.options.showField', { field: t('bulkEdit.fields.place') })}
            invert
            style={{ marginLeft: '20px' }}
          />
          <CheckboxListItem
            selected={form.showChildrenCheckIn}
            onSelect={handleChange('showChildrenCheckIn')}
            label={t('pdf.options.showField', { field: t('fields.checkIn') })}
            invert
            style={{ marginLeft: '20px' }}
          />
          <CheckboxListItem
            selected={form.showChildrenCheckOut}
            onSelect={handleChange('showChildrenCheckOut')}
            label={t('pdf.options.showField', { field: t('fields.checkOut') })}
            invert
            style={{ marginLeft: '20px' }}
          />
        </>
      )}
      <HeaderImage />
    </>
  )
}

const OptionsForm = () => {
  const { t } = useTranslation('serviceOrders')
  return (
    <Sticky>
      <SeparatorWrapper weight={4} usePadding>
        <Title size="h5" color={COLORS.dark3}>
          {t('pdf.options.printSettingsTitle')}
        </Title>
      </SeparatorWrapper>

      <PdfBasicOptionsForm />
      <CustomOptionsForm />
      <Separator weight={4} />
    </Sticky>
  )
}

export default OptionsForm
